






















import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import { InvoiceStatus } from '@/interfaces';
// import axios from "axios";
// import * as CL from "../Mtc_classes";
// import { MtcADMIN } from "../Mtc";
// import AdminTemplate from "../../../dev/Components/AdminTemplate.vue";
// import AdminTitles from "../../../dev/Components/AdminTitles.vue";

class Filterer {
  public Name: string;
  public Value: InvoiceStatus;
}

@Component({
  components: {},
})
export default class StatusFilter extends Vue {
  constructor() {
    super();
  }

  /* LIFECYCLE METHODS */
  mounted() {
    var f: Filterer[] = [];
    f.push(this.Get("Any", InvoiceStatus.Any));
    f.push(this.Get("Ready to Post", InvoiceStatus.ReadyToPost));
    f.push(this.Get("Posted", InvoiceStatus.Posted));
    f.push(this.Get("Drafts", InvoiceStatus.Draft));
    f.push(this.Get("Voided", InvoiceStatus.Voided));

    this.OurFilters = f;
  }

  private Get(name: string, value: InvoiceStatus): Filterer {
    var f = new Filterer();
    f.Name = name;
    f.Value = value;
    return f;
  }

  // created(){}

  /* PROPS VARIABLES, They have to be lower case, or first capital only, 
		otherwise they will fail ! */
  @Prop()
  public value: InvoiceStatus;

  /* PRIVATE VARIABLES, __ POSTFIXED */
  // private myVar__: any;

  /* VUE DATA */
  public OurFilters: Filterer[] = [];

  public OptionSelected: [] = [];

  /* VUE WATCH */
  @Watch("value", {immediate: true})
  onValueChanged(newVal: any, oldVal: any) {
		if (!Array.isArray(newVal)) newVal=[newVal];
		this.OptionSelected = newVal;
	}

  /* VUE COMPUTED METHODS */
  // get date(): Date {
  //   return new Date();
  // }

  /* PRIVATE METHODS */
  // private MyFunction():void{}

  /* VUE METHODS */
  public SetFilters(): void {
    this.$emit("input", this.OptionSelected);
    this.$emit("change", this.OptionSelected);
  }
}
